const ROUTE_FEATURE_KEYS = {
  completedGettingStarted: 'completedGettingStarted', //Completed Getting Started checklist
};

export { ROUTE_FEATURE_KEYS };
